var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "br br-top-0 report-activity-list",
          attrs: {
            border: "",
            "cell-class-name": "py-3",
            "default-expand-all": _vm.isStaffReport,
            "row-key": "id",
            "row-class-name": _vm.isGroupRow,
            data: _vm.rows
          }
        },
        [
          _vm.isStaffReport
            ? _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: _vm.$t.__(
                    "activities.reports.ActivitesReportListing.group"
                  )
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isStaffReport
            ? _c("el-table-column", {
                attrs: {
                  prop: "staff",
                  label: _vm.$t.__("common.labels.staff")
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return _c("span", { staticClass: "flex-level" }, [
                          row.children
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$l10n.__("Totaux groupe:")))
                              ])
                            : _c(
                                "span",
                                [_c("avatar-inline", { attrs: { data: row } })],
                                1
                              )
                        ])
                      }
                    }
                  ],
                  null,
                  false,
                  1427861079
                )
              })
            : _c("el-table-column", {
                attrs: {
                  prop: "period",
                  label: _vm.$t.__(
                    "activities.reports.ActivitesReportListing.period"
                  )
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(scope.row.period) +
                            "\n            "
                        )
                      ]
                    }
                  }
                ])
              }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tasks",
              label: _vm.$t.__(
                "activities.reports.ActivitesReportListing.task_completed"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "calls",
              label: _vm.$t.__(
                "activities.reports.ActivitesReportListing.call_placed"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "emails",
              label: _vm.$t.__(
                "activities.reports.ActivitesReportListing.email_sent"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "events",
              label: _vm.$t.__(
                "activities.reports.ActivitesReportListing.past_event"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "total",
              label: _vm.$t.__(
                "activities.reports.ActivitesReportListing.total"
              )
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }